export default __webpack_public_path__ + "static/douglas-eaec01cec7b6803988196aab177e47cf.svg";